/*  MUI  */
import { Download } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { FontSizes, URLs } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const MobileConfigDownload = ({ stepText }) => {
    const { t } = useTranslation();
    return (
        <Box>
            <Typography
                dangerouslySetInnerHTML={{
                    __html: stepText
                }}
            />
            <Box mt="8px">
                <a
                    href={`${URLs.publicFiles}/AuvikSaaS-macOS.mobileconfig`}
                    className="link--secondary"
                    data-trackid="partner_integrations_mobileConfigDownload_bigSur"
                >
                    <Download
                        style={{
                            fontSize: FontSizes[2],
                            marginRight: '4px'
                        }}
                    />
                    <span>{t('Integrations.Custom.bigSur')}</span>
                </a>
            </Box>
            <Box mt="8px">
                <a
                    href={`${URLs.publicFiles}/AuvikSaaS-macOS-before-v11.mobileconfig`}
                    className="link--secondary"
                    data-trackid="partner_integrations_mobileConfigDownload_Catalina"
                >
                    <Download
                        style={{
                            fontSize: FontSizes[2],
                            marginRight: '4px'
                        }}
                    />
                    <span>{t('Integrations.Custom.catalina')}</span>
                </a>
            </Box>
        </Box>
    );
};
